"use strict";import{tag as l}from"../custom-tag.js";export{setCustomTemplateLiteralTag}from"../custom-tag.js";export const CornerTriangle300Icon=({width:e=24,height:r=24,hidden:t=!1,title:a="Corner Triangle300"}={})=>l`<svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 7 7"
    aria-hidden=${t?"true":"false"}
    role="img"
    fill="currentColor"
    aria-label="${a}"
    width="${e}"
    height="${r}"
  >
    <path
      d="M6.683.67a.32.32 0 0 0-.223.093l-5.7 5.7a.316.316 0 0 0 .224.54h5.7A.316.316 0 0 0 7 6.687V.986A.316.316 0 0 0 6.684.67z"
    />
  </svg>`;
//# sourceMappingURL=CornerTriangle300.js.map
